module.exports = __webpack_public_path__ + "img/mobilesystem3.456f39bd.png";